import { FoodItem } from "../../types";
import { RawCategory, descendantTypes } from "./categories";

/** A merchandising section as /menu/sections returns it. */
export type MenuSectionData = {
  id: string;
  header: string | null;
  order: number;
  widthFull: boolean;
  categoryTypes: string[];
  productIds: string[];
};

/**
 * Every categoryType a section covers — the categories it names plus anything
 * nested under them, so a section pointing at "Cafe Kulachi" also picks up its
 * nine sub-categories.
 */
export const sectionTypes = (
  categories: RawCategory[],
  section: MenuSectionData
): Set<string> => {
  const types = new Set<string>();
  (section?.categoryTypes || []).forEach((t) =>
    descendantTypes(categories || [], t).forEach((d) => types.add(d))
  );
  return types;
};

/** Products in a section: everything in its categories, plus pinned products. */
export const sectionProducts = (
  foodItems: FoodItem[],
  categories: RawCategory[],
  section: MenuSectionData
): FoodItem[] => {
  const types = sectionTypes(categories, section);
  const pinned = new Set(section?.productIds || []);
  return (foodItems || []).filter(
    (p: any) => types.has(p.category) || pinned.has(p.id)
  );
};

/** Sections that actually have something to show, in dashboard order. */
export const stockedSections = (
  sections: MenuSectionData[],
  foodItems: FoodItem[],
  categories: RawCategory[]
) =>
  (sections || [])
    .filter((s) => sectionProducts(foodItems, categories, s).length > 0)
    .sort((a, b) => (a.order || 0) - (b.order || 0));
